module.exports = __webpack_public_path__ + "static/media/competencyy.6679f82e.jpg";